import { render } from "./CompanyMemoPage.vue?vue&type=template&id=1e63d4c4"
import script from "./CompanyMemoPage.vue?vue&type=script&lang=js"
export * from "./CompanyMemoPage.vue?vue&type=script&lang=js"

import "./CompanyMemoPage.vue?vue&type=style&index=0&id=1e63d4c4&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__